import { axiosClient } from 'www/utils'
import type { ApiScheduleNearestSlotsParamsPost, ApiScheduleNearestSlotsResponsePost } from 'www/api/apiScheduleNearestSlots.types'

export default {
  post(params: ApiScheduleNearestSlotsParamsPost) {
    return axiosClient.post<ApiScheduleNearestSlotsResponsePost>('/ajax/schedule/nearest_slots/telemed/', params)
  },
}
